import { Component } from 'react';

class FaqContainer extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="faq-container__background">
        <div className="faq-container row">

          <h1>FAQ</h1>
          <p className="question">Hoe weet ik of mijn geldverstrekker automatische risicoklasse daling (en daarmee
                                  looptijdrente) aanbiedt?</p>
          <p className="answer">
            Er zijn momenteel 18 geldverstrekkers die automatische risicoklassedaling aanbieden; a.s.r., Hypotrust,
            Centraal Beheer, Obvion, Vista, Jungo, Triodos, Robuust, NIBC, Tulp Hypotheken, Merius, MUNT, Venn, Allianz,
            Attens, Colibri, Reaal en IQWOON hanteren een zogeheten looptijdrente, maar dat is niet bij al hun producten het geval. Als een geldverstrekker voor het betreffende product
            looptijdrente aanbiedt, dan kunt u dat zien aan het looptijdrente logo <img
            src="/images/looptijdrente-icoon.png"
            alt="looptijdrentelogo" className="icon"
          /> dat in de
            kolom looptijdrente staat.
            Zie voor meer informatie ook de vragen die hierover door geldverstrekkers zijn beantwoord op <a
            href="http://www.topopslag.nl" target="_blank" rel="noopener noreferrer"
          > www.topopslag.nl</a>.

          </p>
          <p className="question">
            Hoe weet ik of mijn geldverstrekker überhaupt risicoklassedaling mogelijk maakt tijdens de rentevaste
            periode?
          </p>
          <p className="answer">
            Veel geldverstrekkers staan risicoklassedaling toe tijdens de rentvaste periode maar u zult dit verzoek dan
            zelf moeten indienen bij de geldverstrekker. De geldverstrekker kan risicoklassedaling toestaan al gevolg
            van
            maandelijkse of eenmalige aflossingen danwel door waardestijging van uw woning. Kijk op <a
            href="http://www.topopslag.nl" target="_blank" rel="noopener noreferrer"
          > www.topopslag.nl</a> naar de
            voorwaarden die geldverstrekkers op dit onderdeel hanteren of kijk in uw eigen
            hypotheekvoorwaarden.
          </p>
          <p className="question">
            Zijn bij automatische risicoklassedaling de risicoklassen gegarandeerd zoals die gelden op het moment van
            het
            afsluiten van mijn hypotheek?

          </p>
          <p className="answer">De risicoklassen die gelden op het moment van afsluiten van de hypotheek zijn niet bij
                                alle geldverstrekkers gegarandeerd. Kijk in uw hypotheekvoorwaarden of uw
                                hypotheekaanbod wat uw
                                geldverstrekker hierover meldt.
          </p>

          <p className="question">Is het projecteren van de rente-/maandlasten over de hele looptijd van de hypotheek
                                  niet
                                  misleidend
                                  als mijn rentevaste periode korter is dan de looptijd van de hypotheek?
          </p>
          <p className="answer">In het projecteren van de mogelijke besparingen gaan wij voor de hele looptijd van de
                                hypotheek uit
                                van de rente zoals die geldt voor de rentevaste periode. Uiteraard is dit een aanname.
                                De rente zal nagenoeg
                                in alle gevallen na de rentevaste periode anders worden. Toch willen wij ‘een beeld’
                                geven van de
                                besparingen
                                die mogelijk zijn over de gehele looptijd van de hypotheek op basis van deze aanname.
          </p>
          <p className="question">Kan ik ook in risicoklassen dalen als ik een hypotheek met Nationale Hypotheek
                                  Garantie
                                  (NHG) heb?
          </p>
          <p className="answer">Een enkele geldverstrekker hanteert ook risicoklassen binnen een hypotheek met NHG,
                                zoals
                                Delta Lloyd en Allianz.
          </p>
          <p className="question">Ik heb een hypotheek met meerdere leningdelen. Kan ik dat ook berekenen?
          </p>
          <p className="answer">Als u in het menu van de website kiest voor ‘bereken maandlasten’ dan kunt u meerdere
                                leningdelen met eventueel een verschillende aflosvorm kiezen.
          </p>
          <p className="question">Waar kan ik advies krijgen over welke geldverstrekker en hypotheekvorm ik het beste
                                  kan
                                  kiezen?
          </p>
          <p className="answer">Op de website staat in het menu een onderdeel ‘zoek adviseur’. Daar kunt u een adviseur
                                zoeken, bijvoorbeeld bij u in de omgeving.
          </p>
          <p className="question">Kan ik ook in risicoklasse dalen als ik een aflossingsvrije (deel)lening heb?</p>
          <p className="answer">In dat geval is looptijdrente (automatische aanpassing van de schuld-marktwaarde
                                verhouding als gevolg van periodieke en/of incidentele aflossing) alleen aan de orde bij
                                een incidentele
                                aflossing. U lost immers maandelijks niets af op de hypotheekschuld. Daarnaast kan het
                                zijn dat uw woning
                                in waarde is gestegen waardoor uw schuld-marktwaarde verhouding in een lagere
                                risicoklasse terecht is
                                gekomen. Uw geldverstrekker zal u vragen om dit aan te tonen met een taxatierapport.
                                Sommige
                                geldverstrekkers gaan ook akkoord met het overleggen van een modelmatige taxatie (dat is
                                een indicatieve
                                woningwaarde) of een WOZ opgave als de hypotheekschuld lager ligt dan 80% van de
                                woningwaarde.
          </p>
        </div>
      </div>

    );
  }
}

export default FaqContainer;
